export const TISCH_KONFIGURATOR_APP_CODE = 'schrankwerk-tisch';
export const ROLLCONTAINER_KONFIGURATOR_APP_CODE = 'krieger-rollcontainer';
export const AKTENSCHRANK_KONFIGURATOR_APP_CODE = 'krieger-aktenschrank';
export const SCHIEBETUERENSCHRANK_KONFIGURATOR_APP_CODE =
  'krieger-schiebetuerenschrank';
export const EINZELTEIL_KONFIGURATOR_APP_CODE = 'krieger-einzelteil';

export const MODULMOEBEL_KONFIGURATOR_APP_CODES: string[] = [
  ROLLCONTAINER_KONFIGURATOR_APP_CODE,
  AKTENSCHRANK_KONFIGURATOR_APP_CODE,
  SCHIEBETUERENSCHRANK_KONFIGURATOR_APP_CODE,
];

export const isModulmoebelKonfigurator = (appCode: string): boolean => {
  const modulmoebelKonfiguratorAppCodesSet = new Set(
    MODULMOEBEL_KONFIGURATOR_APP_CODES
  );
  return modulmoebelKonfiguratorAppCodesSet.has(appCode);
};
